export default __webpack_public_path__ + "static/icon-22-1-3e25ed8c2d581703b87671c1bb8f6b00.png";